import { useEffect } from 'react';

import termIntelligenceUpsell from '../../assets/termIntelligenceUpsell.gif';
import { fireHeapEvent } from '../../utils/heapUtil';

import { TermIntelligenceText } from './UpsellContent/TermIntelligenceText';

import styles from './UpsellContent/Upsell.module.scss';

export const TermIntelligenceUpsell = () => {
  useEffect(() => {
    const workspaceName = window.location.pathname;
    fireHeapEvent(`${workspaceName} - Upsell`, {}, workspaceName);
  }, []);
  return (
    <div className={styles.page}>
      <div className={styles.imageWrapper}>
        <img src={termIntelligenceUpsell} alt="term-intelligence-upsell" />
      </div>
      <div className={styles.copyTextWrapper}>
        <TermIntelligenceText />
      </div>
    </div>
  );
};
